import { useCallback, useEffect, useRef } from "react";

/** Batch pointer/mouse handlers to one DOM write per animation frame. */
export function useRafMouseHandler(onFrame, { enabled = true } = {}) {
  const onFrameRef = useRef(onFrame);
  onFrameRef.current = onFrame;

  const pendingRef = useRef(null);
  const rafRef = useRef(0);

  const cancel = useCallback(() => {
    if (rafRef.current) {
      cancelAnimationFrame(rafRef.current);
      rafRef.current = 0;
    }
    pendingRef.current = null;
  }, []);

  const handleMove = useCallback(
    (event) => {
      if (!enabled) return;
      pendingRef.current = event;
      if (rafRef.current) return;
      rafRef.current = requestAnimationFrame(() => {
        rafRef.current = 0;
        const pending = pendingRef.current;
        pendingRef.current = null;
        if (pending) onFrameRef.current?.(pending);
      });
    },
    [enabled],
  );

  useEffect(() => () => cancel(), [cancel]);

  return { handleMove, cancelPending: cancel };
}
